import { METHOD_LABELS } from '../constants/driveConstants';

export const formatProcessingTime = (seconds?: number | null) => {
  if (seconds === undefined || seconds === null) {
    return undefined;
  }
  if (seconds < 1) {
    return `${Math.round(seconds * 1000)} ms`;
  }
  if (seconds < 10) {
    return `${seconds.toFixed(1)} s`;
  }
  return `${Math.round(seconds)} s`;
};

export const formatProcessingMethods = (methods?: string[] | null) => {
  if (!methods || methods.length === 0) {
    return undefined;
  }
  const friendly = methods.map((raw) => {
    const failed = raw.endsWith('_failed');
    const baseKey = failed ? raw.replace(/_failed$/, '') : raw;
    const label = METHOD_LABELS[baseKey] ?? baseKey.replace(/_/g, ' ');
    return failed ? `${label} (falló)` : label;
  });
  return friendly.join(', ');
};

// Format RUT (ej: 10503245-5 -> 10.503.245-5)
export const formatRUT = (rut?: string) => {
  if (!rut || rut === '-') return '-';

  // Remover puntos y guiones existentes para normalizar
  const cleanRUT = rut.replace(/\./g, '').replace(/-/g, '');

  // Validar formato básico (debe tener al menos 7 dígitos + 1 dígito verificador)
  if (cleanRUT.length < 8) return rut; // Si es muy corto, devolver original

  // Separar número y dígito verificador
  const number = cleanRUT.slice(0, -1);
  const verifier = cleanRUT.slice(-1).toUpperCase();

  // Formatear número con puntos
  const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedNumber}-${verifier}`;
};

// Format date as DD-MMM-AAAA (ej: 15-Ene-2025)
export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return '-';

  const dateObj = typeof date === 'string' ? new Date(date) : date;

  // Validar que sea una fecha válida
  if (isNaN(dateObj.getTime())) return '-';

  const day = dateObj.getDate().toString().padStart(2, '0');
  const monthNames = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ];
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day}-${month}-${year}`;
};
